/**
 * Las direcciones que hay escritas en un campo de email.
 *
 * Espejo de `destinatarios()` del backend (email_service.py), que es quien
 * manda de verdad. Aquí solo sirve para CONTAR y enseñar a cuántos va antes de
 * darle a enviar; el reparto real lo hace el servidor.
 *
 * Vive suelto y sin importar nada, como `coincidencia.js` e `importes.js`: la
 * primera versión estaba dentro del diálogo, que importa `@/App`, y entonces
 * probar cuatro líneas arrastra la aplicación entera y el router.
 */

/** Devuelve las direcciones válidas, sin duplicados y en el orden escrito. */
export function direccionesDe(valor) {
  const vistos = new Set();
  return String(valor || '')
    .split(/[,;\s]+/)
    .map((d) => d.trim().replace(/^<+|>+$/g, '').replace(/\.+$/, ''))
    .filter((d) => {
      if (!d.includes('@')) return false;
      const clave = d.toLowerCase();
      if (vistos.has(clave)) return false;   // mandar dos veces la misma factura
      vistos.add(clave);
      return true;
    });
}

export default direccionesDe;
